"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.devServerUrl = exports.devServerAvailable = void 0;
const consts_1 = require("./consts");
/**
 * Attempts to contact the dev server, returning a boolean indicating whether or
 * not it was successful.
 *
 * @example devServerUrl(process.env[envKeys.DevServerUrl], "/your-path")
 */
const devServerAvailable = async (
/**
 * The host of the dev server. You should pass in an environment variable as
 * this parameter.
 */
host = consts_1.defaultDevServerHost, 
/**
 * The fetch implementation to use to communicate with the dev server.
 */
fetch) => {
    try {
        const url = (0, exports.devServerUrl)(host, "/dev");
        const result = await fetch(url.toString());
        await result.json();
        return true;
    }
    catch (e) {
        return false;
    }
};
exports.devServerAvailable = devServerAvailable;
/**
 * devServerUrl returns a full URL for the given path name.
 *
 * Because Cloudflare/V8 platforms don't allow process.env, you are expected
 * to pass in the host from the dev server env key:
 *
 * @example devServerUrl(processEnv(envKeys.DevServerUrl), "/your-path")
 * @example devServerUrl("http://localhost:8288/", "/your-path")
 */
const devServerUrl = (host = consts_1.defaultDevServerHost, pathname = "") => {
    return new URL(pathname, host.includes("://") ? host : `http://${host}`);
};
exports.devServerUrl = devServerUrl;
//# sourceMappingURL=devserver.js.map